var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0037 5.11505C7.1679 5.11505 4.87207 7.41338 4.87207 10.2467C4.87207 13.0826 7.1704 15.3784 10.0037 15.3784C12.8396 15.3784 15.1354 13.0801 15.1354 10.2467C15.1354 7.41088 12.8371 5.11505 10.0037 5.11505ZM10.0037 13.5776C8.1629 13.5776 6.6729 12.0867 6.6729 10.2467C6.6729 8.40672 8.16374 6.91588 10.0037 6.91588C11.8437 6.91588 13.3346 8.40672 13.3346 10.2467C13.3354 12.0867 11.8446 13.5776 10.0037 13.5776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1235 0.313219C12.2835 0.227386 7.72602 0.231552 5.88436 0.313219C4.26602 0.389052 2.83852 0.779886 1.68769 1.93072C-0.235644 3.85405 0.0101894 6.44572 0.0101894 10.2466C0.0101894 14.1366 -0.206477 16.6682 1.68769 18.5624C3.61852 20.4924 6.24769 20.2399 10.0035 20.2399C13.8569 20.2399 15.1869 20.2424 16.5494 19.7149C18.4019 18.9957 19.8002 17.3399 19.9369 14.3657C20.0235 12.5249 20.0185 7.96822 19.9369 6.12655C19.7719 2.61572 17.8877 0.486552 14.1235 0.313219ZM17.036 17.2899C15.7752 18.5507 14.026 18.4382 9.97936 18.4382C5.81269 18.4382 4.14186 18.4999 2.92269 17.2774C1.51852 15.8799 1.77269 13.6357 1.77269 10.2332C1.77269 5.62905 1.30019 2.31322 5.92102 2.07655C6.98269 2.03905 7.29519 2.02655 9.96769 2.02655L10.0052 2.05155C14.446 2.05155 17.9302 1.58655 18.1394 6.20655C18.1869 7.26072 18.1977 7.57739 18.1977 10.2457C18.1969 14.3641 18.2752 16.0449 17.036 17.2899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3378 6.11161C16.0001 6.11161 16.537 5.57473 16.537 4.91245C16.537 4.25017 16.0001 3.71329 15.3378 3.71329C14.6756 3.71329 14.1387 4.25017 14.1387 4.91245C14.1387 5.57473 14.6756 6.11161 15.3378 6.11161Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1ebc912a.svg";
export { ForwardRef as ReactComponent };